import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'monthlyTicketCardTypeList',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        searchCriteria:{}
    },
    reducers: {
        get_list: (state,action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria:{...action.payload}
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.items,
                total: action.payload.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: []
            };
        }
    }
});

export const {reducer, actions} = slice;

export default reducer;